export const PaygoLandPlanId = '77609';
export const PaygoLandPlanName = 'Pay As You Go (Land)';
export const PaygoSeaPlanName = 'Pay As You Go (Sea)';